import { useState } from "react";

export const AISandbox = () => {
  const [data, setData] = useState({});

  return <div>AI Sandbox, nothing in testing</div>;
};
